var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/edit-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-2_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M14 14.6666H2C1.72667 14.6666 1.5 14.44 1.5 14.1666C1.5 13.8933 1.72667 13.6666 2 13.6666H14C14.2733 13.6666 14.5 13.8933 14.5 14.1666C14.5 14.44 14.2733 14.6666 14 14.6666Z",
    fill: "#636175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M12.6799 2.31994C11.3866 1.02661 10.1199 0.993275 8.79322 2.31994L7.98655 3.12661C7.91989 3.19328 7.89322 3.29994 7.91989 3.39328C8.42655 5.15994 9.83989 6.57328 11.6066 7.07994C11.6332 7.08661 11.6599 7.09328 11.6866 7.09328C11.7599 7.09328 11.8266 7.06661 11.8799 7.01328L12.6799 6.20661C13.3399 5.55328 13.6599 4.91994 13.6599 4.27994C13.6666 3.61994 13.3466 2.97994 12.6799 2.31994Z",
    fill: "#636175"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.4066 7.68666C10.2132 7.59332 10.0266 7.49999 9.84655 7.39333C9.69989 7.30666 9.55989 7.21333 9.41989 7.11333C9.30655 7.03999 9.17322 6.93332 9.04655 6.82666C9.03322 6.81999 8.98655 6.77999 8.93322 6.72666C8.71322 6.53999 8.46655 6.29999 8.24655 6.03333C8.22655 6.01999 8.19322 5.97333 8.14655 5.91333C8.07989 5.83333 7.96655 5.69999 7.86655 5.54666C7.78655 5.44666 7.69322 5.29999 7.60655 5.15333C7.49989 4.97333 7.40655 4.79332 7.31322 4.60666C7.21989 4.40666 7.14655 4.21333 7.07989 4.03333L2.89322 8.21999C2.80655 8.30666 2.72655 8.47333 2.70655 8.58666L2.34655 11.14C2.27989 11.5933 2.40655 12.02 2.68655 12.3067C2.92655 12.54 3.25989 12.6667 3.61989 12.6667C3.69989 12.6667 3.77989 12.66 3.85989 12.6467L6.41989 12.2867C6.53989 12.2667 6.70655 12.1867 6.78655 12.1L10.9732 7.91333C10.7866 7.84666 10.6066 7.77332 10.4066 7.68666Z",
    fill: "#636175"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.e46459f31a49b417710de35da249631a.svg";
export { ForwardRef as ReactComponent };